/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { type CurrencyAndSymbolName } from "./types";


// noinspection JSUnusedGlobalSymbols
export const EUR: CurrencyAndSymbolName = {
  name:       "Euro",
  symbolName: "Eurosign",
};
